import type { IconData } from '@stacksjs/iconify-core'

export const moonStarsFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M20.5 8.5c-10.493 0-19 8.507-19 19s8.507 19 19 19c7.885 0 14.645-4.803 17.52-11.637c.43-1.023.094-2.035-.535-2.66a2.63 2.63 0 0 0-2.469-.69c-.93.223-1.902.342-2.903.342c-6.84 0-12.385-5.545-12.385-12.384c0-2.791.922-5.362 2.477-7.432a2.24 2.24 0 0 0 .269-2.235A2.14 2.14 0 0 0 20.5 8.5\"/><path fill=\"#2859c5\" d=\"M39.749 11.128c-.714-2.17-3.784-2.17-4.498 0l-1.515 4.608l-4.608 1.515c-2.17.714-2.17 3.784 0 4.498l4.608 1.515l1.515 4.608c.714 2.17 3.784 2.17 4.498 0l1.515-4.608l4.608-1.515c2.17-.714 2.17-3.784 0-4.498l-4.608-1.515zM30.5 4a1.5 1.5 0 0 0-3 0v1.5H26a1.5 1.5 0 0 0 0 3h1.5V10a1.5 1.5 0 0 0 3 0V8.5H32a1.5 1.5 0 0 0 0-3h-1.5z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default moonStarsFlat
